export default [
  {
    path: 'policy_modify',
    component: () => import('@/views/policyModify/PolicyModify'),
    meta: { title: '车险保单保全' },
    children: [
      {
        path: ':id',
        component: () => import('@/views/policyModify/PolicyModifyDetail'),
        props: true,
        meta: { title: '车险保单保全详情' }
      }
    ]
  },
  {
    path: 'general_policy_modify',
    component: () => import('@/views/policyModify/GeneralPolicyModify'),
    meta: { title: '车险保单保全' },
    children: [
      {
        path: ':id',
        component: () => import('@/views/policyModify/GeneralPolicyModifyDetail'),
        props: true,
        meta: { title: '非车险保单保全详情' }
      }
    ]
  }
]
